// packages/api-client/src/services/contextAnalysisService.ts
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse, UUID } from '@dopomogai/types';

export interface ContextUsageBreakdownItem {
  index: number;
  role: string;
  tokens: number;
  preview: string;
}

export interface ContextUsageResponse {
  total_tokens: number;
  history_tokens: number;
  system_tokens: number;
  file_tokens_est: number;
  breakdown: ContextUsageBreakdownItem[];
  model_context_limit: number;
  is_limit_exceeded: boolean;
}

export type ContextUsagePart =
  | { type: 'text'; content: string }
  | { type: 'file'; file_id: UUID; media_type?: string };

export interface ContextUsageRequest {
  agent_id: UUID;
  conversation_id: UUID; // NEW: include to count history on server
  parts: ContextUsagePart[];
  model_descriptor_override?: string;
}

export const contextAnalysisService = {
  /**
   * Preferred for Studio: supports draft parts + model override.
   * POST /api/v1/context/usage/parts
   * Now includes conversation_id to allow server to count history.
   */
  getUsageFromParts: (
    payload: ContextUsageRequest,
    opts?: { signal?: AbortSignal }
  ): ServiceResponse<ContextUsageResponse> => {
    return getApiClient()
      .post<ContextUsageResponse>(`/context/usage/parts`, payload, { signal: opts?.signal })
      .then((r) => r.data)
      .catch((err) => handleApiError(err, 'calculating context usage from parts'));
  },
};